import React, { useState, useEffect } from 'react';
import Loader from './loader';

const OurStory = () => {
  const [img1, setImg1] = useState(true);
  const [img2, setImg2] = useState(true);
  const [img3, setImg3] = useState(true);

  const [offsetY, setOffsetY] = useState(0);
  const handleScrollOurStory = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', handleScrollOurStory);

    return () => window.removeEventListener('scroll', handleScrollOurStory);
  }, []);

  return (
    <>
      {(img1 || img2 || img3) && <Loader />}
      <div className='our-story'>
        <img className='hero-back' src='/img/b1.jpg' alt='background' />
        <div className='b2'>
          <img
            // className='b2'
            src='/img/b2.png'
            alt='b2'
            onLoad={() => setImg1(false)}
            style={{
              transform: `translateY(${offsetY * 0.45}px)`,
            }}
          />
        </div>
        <div className='b3'>
          <img
            // className='b3'
            src='/img/b3.png'
            alt='b3'
            onLoad={() => setImg2(false)}
            style={{
              transform: `translateY(${offsetY * 0.3}px)`,
            }}
          />
        </div>

        <div className='b4'>
          <img
            // className='b4'
            src='/img/b4.png'
            alt='b4'
            onLoad={() => setImg3(false)}
            // style={{
            //   transform: `translateY(${offsetY * 0.05}px)`,
            // }}
          />
        </div>
      </div>
      <div
        style={{ backgroundColor: '#032d4a', color: 'white', padding: '18px' }}
        className='row'
      >
        <div className='col-md-3'></div>
        <div className='col-md-6 '>
          <br />
          <h1>Our Story</h1>
          <p>
            Since 1983 we've been redefining how commercial and hospitality
            interiors work, introducing collections of high-quality furniture
            that bear all the hallmarks of British design and craftsmanship,
            beautifully refined and sartorially detailed. The journey from a
            piece’s initial inception to realisation is a painstaking path to
            follow. The combination of our designers and ergonomists, master
            craftsmen and engineers, all work meticulously, pouring their hearts
            and souls into making fine furniture. Created from quality materials
            and an unwavering commitment to the detail, we have a truly
            exceptional and beautifully refined collection of furniture.
          </p>
          <br />
          <br />
        </div>
        <div className='col-md-3'></div>
      </div>
    </>
  );
};

export default OurStory;
